import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition } from "vue"
import _imports_0 from '@/assets/menu-icon.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-900/80" }, null, -1)
const _hoisted_2 = { class: "fixed inset-0 flex" }
const _hoisted_3 = { class: "absolute left-full top-0 flex w-16 justify-center pt-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close sidebar", -1)
const _hoisted_5 = { class: "flex grow flex-col gap-y-5 overflow-y-auto bg-white pb-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "group flex items-center w-full gap-x-3 rounded-md overflow-hidden text-lg px-4 h-16 font-semibold leading-6 text-black" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "w-10 ml-1 h-10",
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("span", null, "Fundequate")
], -1)
const _hoisted_7 = { class: "flex flex-1 flex-col px-6" }
const _hoisted_8 = {
  role: "list",
  class: "flex flex-1 flex-col gap-y-7"
}
const _hoisted_9 = {
  role: "list",
  class: "-mx-2 space-y-1"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "mt-auto" }
const _hoisted_12 = { class: "flex grow flex-col gap-y-5 overflow-y-auto border-r border-gray-200 bg-white pb-4" }
const _hoisted_13 = { class: "absolute top-0 l-0 w-full h-16" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "flex h-16 px-4 shrink-0 items-center relative" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "group flex items-center w-full gap-x-3 rounded-md overflow-hidden text-lg font-semibold leading-6 text-black" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      class: "w-10 ml-1 h-10",
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("span", null, "Fundequate")
  ])
], -1)
const _hoisted_15 = { class: "flex flex-1 flex-col px-6" }
const _hoisted_16 = {
  role: "list",
  class: "flex flex-1 flex-col gap-y-7"
}
const _hoisted_17 = {
  role: "list",
  class: "-mx-2 space-y-1"
}
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "mt-auto" }
const _hoisted_20 = { class: "sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open sidebar", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", {
  class: "hidden h-6 w-px bg-gray-200 sm:block lg:hidden",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_23 = { class: "flex flex-1 gap-x-4 self-stretch lg:gap-x-6" }
const _hoisted_24 = {
  class: "hidden mr-4 sm:flex",
  "aria-label": "Breadcrumb"
}
const _hoisted_25 = {
  role: "list",
  class: "flex items-center space-x-4"
}
const _hoisted_26 = {
  href: "#",
  class: "flex items-center text-gray-400 hover:text-gray-500"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Home", -1)
const _hoisted_28 = {
  key: 0,
  href: "#",
  class: "ml-4 font-medium text-primary-600 text-sm"
}
const _hoisted_29 = { class: "flex items-center" }
const _hoisted_30 = ["href", "aria-current"]
const _hoisted_31 = { class: "flex items-center gap-x-4 lg:gap-x-6 ml-auto" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open user menu", -1)
const _hoisted_33 = { class: "h-10 w-10 relative" }
const _hoisted_34 = { class: "h-full w-full bg-gray-500 rounded-full overflow-hidden relative" }
const _hoisted_35 = ["src"]
const _hoisted_36 = {
  key: 1,
  class: "leading-[2] absolute inset-0 font-semibold text-xl text-white origin-center"
}
const _hoisted_37 = { class: "context-box w-6 h-6 absolute -right-2 -bottom-1 bg-gray-500 border border-gray-300 rounded-md overflow-hidden ring-white ring-2" }
const _hoisted_38 = ["src", "alt"]
const _hoisted_39 = {
  key: 1,
  class: "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 font-semibold text-sm text-white origin-center"
}
const _hoisted_40 = { class: "hidden lg:flex lg:items-center" }
const _hoisted_41 = { class: "block text-left ml-4 text-sm max-w-fit w-fit overflow-hidden" }
const _hoisted_42 = {
  class: "font-semibold leading-6 text-gray-900",
  "aria-hidden": "true"
}
const _hoisted_43 = { class: "border-b border-solid border-gray-100 mb-2 overflow-hidden pl-4 pr-16 pt-2 pb-4 relative" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-400" }, "Currently logged in at:", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("p", { class: "text-md text-black font-semibold -mt-1 whitespace-nowrap overflow-hidden overflow-ellipsis" }, " High Capital Management sp. z o.o.", -1)
const _hoisted_46 = { class: "py-10" }
const _hoisted_47 = { class: "px-4 sm:px-6 lg:px-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!
  const _component_ChevronRightIcon = _resolveComponent("ChevronRightIcon")!
  const _component_DisclosureButton = _resolveComponent("DisclosureButton")!
  const _component_DisclosurePanel = _resolveComponent("DisclosurePanel")!
  const _component_Disclosure = _resolveComponent("Disclosure")!
  const _component_ArrowLeftOnRectangleIcon = _resolveComponent("ArrowLeftOnRectangleIcon")!
  const _component_DialogPanel = _resolveComponent("DialogPanel")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!
  const _component_ArrowUpLeftIcon = _resolveComponent("ArrowUpLeftIcon")!
  const _component_ArrowDownRightIcon = _resolveComponent("ArrowDownRightIcon")!
  const _component_Bars3Icon = _resolveComponent("Bars3Icon")!
  const _component_HomeIcon = _resolveComponent("HomeIcon")!
  const _component_ArrowPathRoundedSquareIcon = _resolveComponent("ArrowPathRoundedSquareIcon")!
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_ContextsModal = _resolveComponent("ContextsModal")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_TransitionRoot, {
      as: "template",
      show: _ctx.sidebarOpen
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Dialog, {
          as: "div",
          class: "relative z-50 lg:hidden",
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sidebarOpen = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TransitionChild, {
              as: "template",
              enter: "transition-opacity ease-linear duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "transition-opacity ease-linear duration-300",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ], undefined, true),
              _: 1
            }),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "transition ease-in-out duration-300 transform",
                "enter-from": "-translate-x-full",
                "enter-to": "translate-x-0",
                leave: "transition ease-in-out duration-300 transform",
                "leave-from": "translate-x-0",
                "leave-to": "-translate-x-full"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DialogPanel, { class: "relative mr-16 flex w-full max-w-xs flex-1" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_TransitionChild, {
                        as: "template",
                        enter: "ease-in-out duration-300",
                        "enter-from": "opacity-0",
                        "enter-to": "opacity-100",
                        leave: "ease-in-out duration-300",
                        "leave-from": "opacity-100",
                        "leave-to": "opacity-0"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "-m-2.5 p-2.5",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sidebarOpen = false))
                            }, [
                              _hoisted_4,
                              _createVNode(_component_XMarkIcon, {
                                class: "h-6 w-6 text-white",
                                "aria-hidden": "true"
                              })
                            ])
                          ])
                        ], undefined, true),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_5, [
                        _hoisted_6,
                        _createElementVNode("nav", _hoisted_7, [
                          _createElementVNode("ul", _hoisted_8, [
                            _createElementVNode("li", null, [
                              _createElementVNode("ul", _hoisted_9, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigation, (item) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: item.name
                                  }, [
                                    (!item.children)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          href: item.href,
                                          class: _normalizeClass([item.current ? 'bg-gray-50' : 'hover:bg-gray-50', 'group flex gap-x-3 rounded-md p-3 text-sm leading-6 font-semibold text-gray-700 overflow-hidden'])
                                        }, [
                                          (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                                            class: "h-6 w-6 shrink-0 text-gray-400",
                                            "aria-hidden": "true"
                                          })),
                                          _createTextVNode(" " + _toDisplayString(item.name), 1)
                                        ], 10, _hoisted_10))
                                      : (_openBlock(), _createBlock(_component_Disclosure, {
                                          key: 1,
                                          as: "div"
                                        }, {
                                          default: _withCtx(({ open }) => [
                                            _createVNode(_component_DisclosureButton, {
                                              class: _normalizeClass([item.current ? 'bg-gray-50' : 'hover:bg-gray-50', 'flex items-center w-full text-left rounded-md p-3 gap-x-3 text-sm leading-6 font-semibold text-gray-700 overflow-hidden'])
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                                                  class: "h-6 w-6 shrink-0 text-gray-400",
                                                  "aria-hidden": "true"
                                                })),
                                                _createTextVNode(" " + _toDisplayString(item.name) + " ", 1),
                                                _createVNode(_component_ChevronRightIcon, {
                                                  class: _normalizeClass([open ? 'rotate-90 text-gray-500' : 'text-gray-400', 'ml-auto h-5 w-5 shrink-0']),
                                                  "aria-hidden": "true"
                                                }, null, 8, ["class"])
                                              ], undefined, true),
                                              _: 2
                                            }, 1032, ["class"]),
                                            _createVNode(_component_DisclosurePanel, {
                                              as: "ul",
                                              class: "mt-1 px-2 overflow-hidden"
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (subItem) => {
                                                  return (_openBlock(), _createElementBlock("li", {
                                                    key: subItem.name
                                                  }, [
                                                    _createVNode(_component_DisclosureButton, {
                                                      as: "a",
                                                      href: subItem.href,
                                                      class: _normalizeClass([subItem.current ? 'bg-gray-50' : 'hover:bg-gray-50', 'block text-nowrap rounded-md py-2 pr-2 pl-10 text-sm leading-6 text-gray-700 overflow-hidden'])
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(subItem.name), 1)
                                                      ], undefined, true),
                                                      _: 2
                                                    }, 1032, ["href", "class"])
                                                  ]))
                                                }), 128))
                                              ], undefined, true),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024))
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("li", _hoisted_11, [
                              _createElementVNode("a", {
                                href: "#",
                                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)), ["prevent"])),
                                class: "group -mx-2 flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50 hover:text-primary-600"
                              }, [
                                _createVNode(_component_ArrowLeftOnRectangleIcon, {
                                  class: "h-6 w-6 shrink-0 text-gray-400 group-hover:text-primary-600",
                                  "aria-hidden": "true"
                                }),
                                _createTextVNode(" Sign out ")
                              ])
                            ])
                          ])
                        ])
                      ])
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              })
            ])
          ], undefined, true),
          _: 1
        })
      ], undefined, true),
      _: 1
    }, 8, ["show"]),
    _createElementVNode("div", {
      class: _normalizeClass(['hidden transition-all duration-300 lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:flex-col', _ctx.isExpanded ? 'lg:w-72 lg:max-w-72' : 'lg:w-20 lg:max-w-20'])
    }, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isExpanded = !_ctx.isExpanded)),
            class: "absolute z-10 w-6 h-6 rounded-md bg-white border border-gray-200 -right-3 top-1/2 -translate-y-1/2 cursor-pointer hover:bg-gray-50 transition"
          }, [
            _createVNode(_component_ArrowUpLeftIcon, {
              class: _normalizeClass([_ctx.isExpanded ? 'transform -rotate-90' : 'rotate-90', 'right-1 top-1 transition delay-300 duration-300 pointer-events-none absolute w-2 h-2'])
            }, null, 8, ["class"]),
            _createVNode(_component_ArrowDownRightIcon, {
              class: _normalizeClass([_ctx.isExpanded ? 'transform -rotate-90' : 'rotate-90', 'left-1 bottom-1 transition delay-300 duration-300 pointer-events-none absolute w-2 h-2'])
            }, null, 8, ["class"])
          ])
        ]),
        _hoisted_14,
        _createElementVNode("nav", _hoisted_15, [
          _createElementVNode("ul", _hoisted_16, [
            _createElementVNode("li", null, [
              _createElementVNode("ul", _hoisted_17, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigation, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: item.name
                  }, [
                    (!item.children)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: item.href,
                          class: _normalizeClass([item.current ? 'bg-gray-50' : 'hover:bg-gray-50', 'group flex gap-x-3 rounded-md p-3 text-sm leading-6 font-semibold text-gray-700 overflow-hidden'])
                        }, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                            class: "h-6 w-6 shrink-0 text-gray-400",
                            "aria-hidden": "true"
                          })),
                          _createTextVNode(" " + _toDisplayString(item.name), 1)
                        ], 10, _hoisted_18))
                      : (_openBlock(), _createBlock(_component_Disclosure, {
                          key: 1,
                          as: "div"
                        }, {
                          default: _withCtx(({ open }) => [
                            _createVNode(_component_DisclosureButton, {
                              class: _normalizeClass([item.current ? 'bg-gray-50' : 'hover:bg-gray-50', 'flex items-center w-full text-left rounded-md p-3 gap-x-3 text-sm leading-6 font-semibold text-gray-700 overflow-hidden'])
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                                  class: "h-6 w-6 shrink-0 text-gray-400",
                                  "aria-hidden": "true"
                                })),
                                _createTextVNode(" " + _toDisplayString(item.name) + " ", 1),
                                _createVNode(_component_ChevronRightIcon, {
                                  class: _normalizeClass([open ? 'rotate-90 text-gray-500' : 'text-gray-400', 'ml-auto h-5 w-5 shrink-0']),
                                  "aria-hidden": "true"
                                }, null, 8, ["class"])
                              ], undefined, true),
                              _: 2
                            }, 1032, ["class"]),
                            _createVNode(_component_DisclosurePanel, {
                              as: "ul",
                              class: "mt-1 px-2 overflow-hidden"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (subItem) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: subItem.name
                                  }, [
                                    _createVNode(_component_DisclosureButton, {
                                      as: "a",
                                      href: subItem.href,
                                      class: _normalizeClass([subItem.current ? 'bg-gray-50' : 'hover:bg-gray-50', 'block text-nowrap rounded-md py-2 pr-2 pl-10 text-sm leading-6 text-gray-700 overflow-hidden'])
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(subItem.name), 1)
                                      ], undefined, true),
                                      _: 2
                                    }, 1032, ["href", "class"])
                                  ]))
                                }), 128))
                              ], undefined, true),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("li", _hoisted_19, [
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)), ["prevent"])),
                class: "group -mx-2 flex gap-x-3 rounded-md p-3 text-sm font-semibold overflow-hidden text-nowrap leading-6 text-gray-700 hover:bg-gray-50 hover:text-primary-600"
              }, [
                _createVNode(_component_ArrowLeftOnRectangleIcon, {
                  class: "h-6 w-6 shrink-0 text-gray-400 group-hover:text-primary-600",
                  "aria-hidden": "true"
                }),
                _createTextVNode(" Sign out ")
              ])
            ])
          ])
        ])
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(['transition-all duration-300', _ctx.isExpanded ? 'lg:pl-72' : 'lg:pl-20'])
    }, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("button", {
          type: "button",
          class: "-m-2.5 p-2.5 text-gray-700 lg:hidden",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sidebarOpen = true))
        }, [
          _hoisted_21,
          _createVNode(_component_Bars3Icon, {
            class: "h-6 w-6",
            "aria-hidden": "true"
          })
        ]),
        _hoisted_22,
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("nav", _hoisted_24, [
            _createElementVNode("ol", _hoisted_25, [
              _createElementVNode("li", null, [
                _createElementVNode("div", null, [
                  _createElementVNode("a", _hoisted_26, [
                    _createVNode(_component_HomeIcon, {
                      class: "h-5 w-5 flex-shrink-0",
                      "aria-hidden": "true"
                    }),
                    _hoisted_27,
                    (!_ctx.pages?.length)
                      ? (_openBlock(), _createElementBlock("a", _hoisted_28, "Welcome Page"))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: page.name
                }, [
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_ChevronRightIcon, {
                      class: "h-5 w-5 flex-shrink-0 text-gray-400",
                      "aria-hidden": "true"
                    }),
                    _createElementVNode("a", {
                      href: page.href,
                      class: _normalizeClass(['ml-4 text-sm font-medium', page?.current ? 'text-primary-600' : 'text-gray-500 hover:text-gray-700']),
                      "aria-current": page.current ? 'page' : undefined
                    }, _toDisplayString(page.name), 11, _hoisted_30)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createVNode(_component_Menu, {
              as: "div",
              class: "relative"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_MenuButton, { class: "-m-1.5 flex items-center p-1.5" }, {
                  default: _withCtx(() => [
                    _hoisted_32,
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        (_ctx.user?.logo)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              class: "w-full h-full object-cover",
                              src: _ctx.user?.logo ? _ctx.user?.logo : null,
                              alt: ""
                            }, null, 8, _hoisted_35))
                          : (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.$filters.uppercase(_ctx.user?.firstName?.slice(0, 1))), 1))
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", {
                          class: "absolute top-0 left-0 w-full h-full bg-gray-500 duration-200 text-white opacity-0 hover:opacity-100",
                          onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openContextsModal && _ctx.openContextsModal(...args)), ["stop"]))
                        }, [
                          _createVNode(_component_ArrowPathRoundedSquareIcon, { class: "w-4 h-4 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" })
                        ]),
                        (_ctx.currentContext?.logo)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              class: "w-full h-full object-cover",
                              src: _ctx.currentContext?.logo,
                              alt: _ctx.currentContext?.name
                            }, null, 8, _hoisted_38))
                          : (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_ctx.$filters.uppercase(_ctx.currentContext?.name?.slice(0, 1))), 1))
                      ])
                    ]),
                    _createElementVNode("span", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.user?.firstName || "") + " " + _toDisplayString(_ctx.user?.surname || ""), 1)
                      ]),
                      _createVNode(_component_ChevronDownIcon, {
                        class: "ml-2 h-5 w-5 text-gray-400",
                        "aria-hidden": "true"
                      })
                    ])
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(_Transition, {
                  "enter-active-class": "transition ease-out duration-100",
                  "enter-from-class": "transform opacity-0 scale-95",
                  "enter-to-class": "transform opacity-100 scale-100",
                  "leave-active-class": "transition ease-in duration-75",
                  "leave-from-class": "transform opacity-100 scale-100",
                  "leave-to-class": "transform opacity-0 scale-95"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_MenuItems, { class: "absolute right-0 z-10 mt-2.5 w-64 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_43, [
                          _hoisted_44,
                          _hoisted_45,
                          _createElementVNode("div", {
                            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.openContextsModal && _ctx.openContextsModal(...args))),
                            class: "absolute right-4 top-1/2 transform -translate-y-1/2 w-6 h-6 cursor-pointer hover:text-primary-600"
                          }, [
                            _createVNode(_component_ArrowPathRoundedSquareIcon, { class: "w-full h-full" })
                          ])
                        ]),
                        _createVNode(_component_MenuItem, null, {
                          default: _withCtx(({ active }) => [
                            _createElementVNode("a", {
                              href: "#",
                              class: _normalizeClass([
                        active ? 'bg-gray-50' : '',
                        'block px-4 py-2 text-sm leading-6 text-gray-900',
                      ])
                            }, "Your profile", 2)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_MenuItem, null, {
                          default: _withCtx(({ active }) => [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)), ["prevent"])),
                              class: _normalizeClass([
                        active ? 'bg-gray-50' : '',
                        'block px-4 py-2 text-sm leading-6 text-gray-900',
                      ])
                            }, "Sign out", 2)
                          ]),
                          _: 1
                        })
                      ], undefined, true),
                      _: 1
                    })
                  ], undefined, true),
                  _: 1
                })
              ], undefined, true),
              _: 1
            })
          ])
        ])
      ]),
      _createVNode(_component_ContextsModal, {
        open: _ctx.showContextsModal,
        userData: _ctx.userData,
        onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"])),
        onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showContextsModal = false))
      }, null, 8, ["open", "userData"]),
      _createElementVNode("main", _hoisted_46, [
        _createElementVNode("div", _hoisted_47, [
          _createVNode(_component_router_view)
        ])
      ])
    ], 2)
  ]))
}